import Navbar from "./components/Navabar";
import Main from "./components/MainSite";
import Carousels from "./components/Carousels";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Main />
    </div>
  );
}

export default App;
